<script setup lang="ts">
import { createUser } from '@/api/user/api';
import { CreateUserDto } from '@/api/user/types';
import { getErrorMessage } from '@/helpers/error-handler';
import { useToastStore } from '@/stores/toast.store';
import { VueformElement } from '@vueform/vueform';
import { Ref, ref } from 'vue';

interface FormData {
  email: string;
  password: string;
  isAdmin: boolean;
}

const toast = useToastStore();

const emit = defineEmits(['finished']);

const form$: Ref<VueformElement | null> = ref(null);

const insertData = async (form$: VueformElement) => {
  const data = form$.data as FormData;

  form$.submitting = true;

  try {
    const createOrderDto: CreateUserDto = {
      email: data.email,
      password: data.password,
      isAdmin: data.isAdmin,
    };
    const { data: userData } = await createUser(createOrderDto);
    toast.addToast({
      title: 'Votre utilisateur a bien été ajouté',
      message: `Votre utilisateur (#${userData.id}) a bien été ajouté`,
      type: 'success',
      duration: 2000,
    });
  } catch (error) {
    console.error('error', error);
    toast.addToast({
      title: "Impossible d'ajouter un utilisateur",
      message: getErrorMessage(error),
      type: 'danger',
      duration: 5000,
    });
    return;
  } finally {
    form$.submitting = false;
    form$.reset();
    emit('finished');
  }
};
</script>

<template>
  <Vueform ref="form$" size="md" :endpoint="false" @submit="insertData">
    <TextElement name="email" input-type="email" :rules="['required', 'email']" label="Email" />
    <TextElement name="password" input-type="password" :rules="['required']" label="Mot de passe" />
    <ToggleElement name="isAdmin"> Admin </ToggleElement>
    <ButtonElement name="submit" button-label="Ajouter" :submits="true" align="right" />
  </Vueform>
</template>

<style scoped>
.avatars {
  margin-left: 1em;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10px, max-content));
}
</style>
